import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/Navbar/logo.png";
import signup from "../assets/signup/signup.png";

function Signup() {
    const [name, setName] = useState("");
    const [add1, setAdd1] = useState("");
    const [add2, setAdd2] = useState("");
    const [add4, setAdd4] = useState("");
    const [mobile, setMobile] = useState("");
    const [taxno, setTaxno] = useState("");
    const [pinCode, setPinCode] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [agentCode, setCode] = useState("");
    const [usernameError, setUsernameError] = useState("");

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const validateUsername = (value) => {
        // Only letters (a-z A-Z) and numbers (0-9) allowed
        const regex = /^[a-zA-Z0-9]+$/;
        if (!value) {
            return "Username is required";
        }
        if (!regex.test(value)) {
            return "Username can only contain letters and numbers (no spaces, #, @, etc.)";
        }
        if (value.length < 4) {
            return "Username must be at least 4 characters";
        }
        if (value.length > 30) {
            return "Username is too long (max 30 characters)";
        }
        return ""; // empty = valid
    };

    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();

        // Convert the shop name to uppercase
        const uppercaseName = name.toUpperCase();

        // Validation checks
        // if (email && !validateEmail(email)) {
        //   alert("Please enter a valid email address.");
        //   return;
        // }

        if (!validateMobileNumber(mobile)) {
            alert("Please enter a 10-digit mobile number.");
            return;
        }

        if (!validatePinCode(pinCode)) {
            alert("Please enter a 6-digit pin code.");
            return;
        }

        // Create an object with the form data
        const formData = {
            name: uppercaseName,
            add1,
            add2,
            add4,
            mobile,
            taxno,
            pinCode,
            username,
            password,
            agentCode,
        };

        // Wrap the form data object in an array
        const requestData = [formData];

        console.log("Request Body:", JSON.stringify(requestData));

        // Make the signup API call
        fetch(`${apiBaseUrl}/user/SignUp/JAPAN_ACCESORIES`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        })
            .then((response) => response.json())
            .then((data) => {
                // Handle the response from the signup API
                console.log(data);
                // Reset the form fields
                setName("");
                setAdd1("");
                setAdd2("");
                setAdd4("");
                setMobile("");
                setTaxno("");
                setPinCode("");
                setUsername("");
                setPassword("");
                setCode("");

                // Show a success message to the user
                if (data === 1) {
                    alert("Form submitted successfully!");

                    // console.log("username:",username);
                    // console.log("password:",password);

                    // Construct the login URL with the username and password as query parameters
                    const loginURL = `${apiBaseUrl}/user/SignIn/JAPAN_ACCESORIES?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`;

                    // Prepare the login request body including the Ledname
                    const loginData = {
                        Ledname: name,
                    };

                    // Make the login API call
                    fetch(loginURL, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(loginData),
                    })
                        .then((response) => response.json())
                        .then((loginResponse) => {
                            // Handle the response from the login API
                            console.log(loginResponse);
                            // Show a success message to the user
                            if (loginResponse.success) {
                                alert("Login successful!");
                                // Redirect the user to the dashboard or home page
                                navigate("/");
                            } else {
                                alert("Login failed.");
                            }
                        })

                        .catch((error) => {
                            // Handle any errors
                            console.error("Error:", error);
                            //   // Show an error message to the user
                            //   alert(
                            //     "An error occurred while logging in. Please try again later."
                            //   );
                        });

                    // console.log("username1:",username);
                    // console.log("password1:",password);

                    // In the component where you navigate to the Otp component
                    navigate("/Otp", { state: { username, password } });
                } else if (data === 0) {
                    alert("Already registered.");
                } else {
                    alert("Registration failed.");
                }
            })
            .catch((error) => {
                // Handle any errors
                console.error("Error:", error);
                // Show an error message to the user
                alert("An error occurred while submitting the form. Please try again later.");
            });
    };

    // const validateEmail = (email) => {
    //   // Regular expression for email validation
    //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   return emailRegex.test(email);
    // };

    const validateMobileNumber = (mobileNumber) => {
        // Regular expression for 10-digit number validation
        const mobileNumberRegex = /^\d{10}$/;
        return mobileNumberRegex.test(mobileNumber);
    };

    const validatePinCode = (pinCode) => {
        // Regular expression for 6-digit number validation
        const pinCodeRegex = /^\d{6}$/;
        return pinCodeRegex.test(pinCode);
    };

    const home = async () => {
        navigate("/login");
    };

    return (
        <div className="min-h-screen   flex flex-col">
            {/* <div className='h-[80px] px-5 lg:px-12 w-full flex justify-start items-center '>
                <img src={logo} alt='logo' />
            </div> */}
            <div className="min-h-screen w-[100%]  flex flex-row justify-center items-center gap-12 px-5 lg:px-[0]">
                <div className="w=[60%] hidden lg:block">
                    <div className="w-[536px]  h-[496px] ">
                        <img src={signup} alt="signup" style={{ height: "100%", width: "100%" }} />
                    </div>
                </div>
                <div className="lg:w-[40%] w-[100%]  flex flex-col gap-12 ">
                    <span className="font-display text-3xl text-[600] flex flex-col gap-3">
                        Create an account{" "}
                        <span className="font-display text-base text-[300] flex flex-row">
                            Already have an account ? &nbsp;
                            <span
                                className="text-base font-display text-[600] text-[#8B0000] underline cursor-pointer"
                                onClick={home}
                            >
                                Login
                            </span>
                        </span>
                    </span>
                    <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
                        <div className="flex  row gap-10 w-[100%] ">
                            <div className="flex flex-col gap-2 w-[50%]">
                                <label className="text-base text-[500] font-display">Shop name</label>
                                <input
                                    className="w-[100%] h-[45px] rounded-[10px] border-[1px] border-[red] pl-4"
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="flex flex-col gap-2 w-[50%]">
                                <label className="text-base text-[500] font-display">Mobile number</label>
                                <input
                                    className="w-[100%] h-[45px] rounded-[10px] border-[1px] border-[red] pl-4"
                                    type="text"
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                        <div className="flex  row gap-10 w-[100%]">
                            <div className="flex flex-col gap-2 w-[50%]">
                                <label className="text-base text-[500] font-display">Address 1</label>
                                <input
                                    className="w-[100%] h-[45px] rounded-[10px] border-[1px] border-[#DFDFDF] pl-4"
                                    type="text"
                                    value={add1}
                                    onChange={(e) => setAdd1(e.target.value)}
                                />
                            </div>
                            <div className="flex flex-col gap-2 w-[50%]">
                                <label className="text-base text-[500] font-display">GST number</label>
                                <input
                                    className="w-[100%] h-[45px] rounded-[10px] border-[1px] border-[#DFDFDF] pl-4"
                                    type="text"
                                    value={taxno}
                                    onChange={(e) => setTaxno(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="flex  row gap-10 w-[100%]">
                            <div className="flex flex-col gap-2  w-[50%]">
                                <label className="text-base text-[500] font-display">Address 2</label>
                                <input
                                    className="w-[100%] h-[45px] rounded-[10px] border-[1px] border-[#DFDFDF] pl-4"
                                    type="text"
                                    value={add2}
                                    onChange={(e) => setAdd2(e.target.value)}
                                />
                            </div>
                            <div className="flex flex-col gap-2 w-[50%]">
                                <label className="text-base text-[500] font-display">Pincode</label>
                                <input
                                    className="w-[100%] h-[45px] rounded-[10px] border-[1px] border-[red] pl-4"
                                    type="text"
                                    value={pinCode}
                                    onChange={(e) => setPinCode(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                        <div className="flex  row gap-10 w-[100%]">
                            <div className="flex flex-col gap-2 w-[50%]">
                                <label className="text-base text-[500] font-display">Agent code / Dealer code</label>
                                <input
                                    className="w-[100%] h-[45px] rounded-[10px] border-[1px] border-[#DFDFDF] pl-4"
                                    type="text"
                                    value={agentCode}
                                    onChange={(e) => setCode(e.target.value)}
                                />
                            </div>
                            <div className="flex flex-col gap-2 w-[50%]">
                                <label className="text-base text-[500] font-display">Username</label>
                                <input
                                    className={`w-[100%] h-[45px] rounded-[10px] pl-4 border-[1px] ${
                                        usernameError ? "border-red-600 focus:ring-red-500" : "border-[red]" // your original red border
                                    }`}
                                    type="text"
                                    value={username}
                                    onChange={(e) => {
                                        const newValue = e.target.value;
                                        setUsername(newValue);
                                        setUsernameError(validateUsername(newValue)); // live check
                                    }}
                                    required
                                />
                                {usernameError && <p className="text-red-600 text-sm mt-1 font-medium">{usernameError}</p>}
                            </div>
                        </div>
                        <div className="flex  row gap-10 w-[100%]">
                            <div className="flex flex-col gap-2 w-[50%]">
                                <label className="text-base text-[500] font-display">Contact person</label>
                                <input
                                    className="w-[100%] h-[45px] rounded-[10px] border-[1px] border-[red] pl-4"
                                    type="text"
                                    value={add4}
                                    onChange={(e) => setAdd4(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="flex flex-col gap-2 w-[50%]">
                                <label className="text-base text-[500] font-display">Password</label>
                                <input
                                    className="w-[100%] h-[45px] rounded-[10px] border-[1px] border-[red] pl-4"
                                    type="text"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                        <button
                            type="submit"
                            className="w-[100%] h-[54px] bg-[#8B0000] flex justify-center items-center text-2xl text-[600] font-display text-[white] rounded-[10px]"
                        >
                            Sign up
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Signup;
